import { useMutation } from "@tanstack/react-query";
import type { UseMutationResult } from "@tanstack/react-query";

import PublicAdminPanelInstance from "../../api/PublicAdminPanelInstance";
import { API_ROUTES } from "../../api/ApiRoutes";
import type {
  ApiSuccessEnvelope,
  PortalSignInData,
  PortalSignInRequest,
} from "../../types/affiliates";

export const postPortalSignIn = async (
  payload: PortalSignInRequest,
): Promise<PortalSignInData> => {
  // Public instance on purpose — the portal sign-in route is unauthenticated,
  // and we explicitly don't want to attach a staff Bearer token if there's an
  // operator session in another tab.
  const response = await PublicAdminPanelInstance.post<
    ApiSuccessEnvelope<PortalSignInData>
  >(API_ROUTES.AFFILIATE_PORTAL_SIGN_IN, payload);
  return response.data.data;
};

export const usePortalSignIn = (): UseMutationResult<
  PortalSignInData,
  Error,
  PortalSignInRequest
> =>
  useMutation({
    mutationKey: ["affiliate-portal", "sign-in"],
    mutationFn: postPortalSignIn,
  });
